export default "__VITE_ASSET__CbxMRLqH__"